// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Cr","landingPageVideo":"Dr","play":"Er","iframeVideo":"Fr","playHidden":"Gr","playVisible":"Hr","fullwidth":"Ir"};